/*
 * @Author: DQL
 * @Date: 2020-08-18 14:56:20
 * @LastEditors: DQL
 * @LastEditTime: 2021-04-30 15:20:27
 * @Description: 管理员级别维护的API服务
 */
import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

export const adminLevelManageService = {
  // 获取管理员列表
  list: () => { return axios.get(`${commontCtx}/amdinUser`); },

  // 保存管理员
  save: (fd) => { return axios.post(`${commontCtx}/amdinUser`, fd); },

  // 删除管理员
  delete: (fd) => { return axios.delete(`${commontCtx}/amdinUser`, { data: fd }); },

  // 获取管理员的数据权限部门
  getDeptTree: () => { return axios.get(`${commontCtx}/dept/tree`); },

  // 获取机构部门下的用户列表（不是管理员）
  getDeptUsers: (deptCode) => { return axios.get(`${commontCtx}/amdinUser/users/${deptCode}`); }
};
